<template>
    <div style="margin:0 10px">
        <router-view></router-view>
        <div class="card">
            <!-- search -->
            <div class="search d-flex a-center j-sb">
                <div class="d-flex a-center">
                    <div style="width:200px;margin-right:10px;">
                        <el-input type="text" v-model="query.keyword" placeholder="请输入知识点名称" class="search-input"></el-input>  
                    </div>
                    <div style="width:150px;margin-right:10px;">
                        <el-select v-model="query.courseId" placeholder="选择课程" clearable class="search-input">
                            <el-option
                                v-for="item in courseList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <el-button class="search-button" @click="init"></el-button>
                    <el-button class="add-button" @click="$router.push({name:'knowledge_graph_add'})"></el-button>
                </div>
                <div class="d-flex a-center">
                    <el-button type="primary" plain @click="$router.push({name:'knowledge_graph_relation'})">
                        <i class="el-icon-connection"></i> 关系管理
                    </el-button>
                    <el-button type="success" plain @click="$router.push({name:'knowledge_graph_view'})">
                        <i class="el-icon-data-analysis"></i> 图谱可视化
                    </el-button>
                </div>
            </div>

            <!-- handle -->
            <div class="handle"></div>

            <!-- table -->
            <div class="table" style="margin-top:20px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    v-loading="loading"
                    element-loading-background="rgba(255,255,255, 0.6)"
                    :header-cell-style="{background:'#f8f8f9',color:'#606266',borderBottom:'1px solid #e8eaec',padding:'8px 0',fontWeight:'700'}"
                >
                    <el-table-column prop="code" label="知识点编码" align="center" width="150"></el-table-column>
                    <el-table-column prop="name" label="知识点名称" align="center" min-width="150"></el-table-column>
                    <el-table-column prop="chapterName" label="所属章节" align="center" width="150"></el-table-column>
                    <el-table-column prop="courseName" label="所属课程" align="center" width="150"></el-table-column>
                    <el-table-column prop="description" label="描述" align="center" min-width="200" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="创建时间" align="center" width="170">
                        <template slot-scope="scope">
                            {{ formatTime(scope.row.createTime) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作" align="center" width="150">
                        <template slot-scope="scope">
                            <el-button @click="$router.push({name:'knowledge_graph_add',query:{id:scope.row.id}})" type="text" size="small" class="edit-action">编辑</el-button>
                            <el-popconfirm
                                style="margin-left: 10px;"
                                title="是否确定删除？"
                                @confirm="handleDel(scope.row)"
                            >
                                <el-button type="text" slot="reference" size="small" class="delete-action">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- page -->
                <div style="margin-top:20px;text-align:center">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :total="total"
                        :page-size="query.size"
                        :page-sizes="pageSizes"
                        :current-page="query.page"
                        @current-change="handlePageChange"
                        @size-change="handleSizeChange"
                    >
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { page, del } from '@/request/api/knowledge_graph.js'
import moment from 'moment'

export default {
    data() {
        return {
            tableData: [],
            query: { keyword: '', courseId: '', page: 1, size: 10 },
            pageSizes: [10, 30, 50, 100],
            total: 0,
            loading: false,
            courseList: [] // TODO: 从课程接口加载
        }
    },
    watch: {
        $route(val, old) {
            if (val.name == 'knowledge_graph') {
                this.init()
            }
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.loading = true
            page(this.query).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data.list || []
                    this.total = res.data.total || 0
                }
            }).finally(() => {
                this.loading = false
            })
        },
        handlePageChange(page) {
            this.query.page = page
            this.init()
        },
        handleSizeChange(size) {
            this.query.size = size
            this.query.page = 1
            this.init()
        },
        handleDel(data) {
            del(data.id).then(res => {
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg })
                this.init()
                this.$notify({ title: '成功', message: '删除成功', type: 'success' })
            })
        },
        formatTime(time) {
            if (!time) return '-'
            return moment(time).format('YYYY-MM-DD HH:mm')
        }
    }
}
</script>

<style scoped lang="less">
.edit-action {
    color: #409eff;
    &:hover {
        color: #66b1ff;
    }
}
.delete-action {
    color: #f56c6c;
    &:hover {
        color: #f78989;
    }
}
</style>
